
import Vue from "vue";
import NotificationAlert from "@/components/common/NotificationAlert.vue";
export default Vue.extend({
  components: {
    NotificationAlert,
  },
});
